import { getAsyncActionFactory } from '../../core/redux/utils/action-class-factory';

const createAsyncAction = getAsyncActionFactory('idp');

export const FetchIdentityProviders = createAsyncAction<null, null>(
  'FETCH_ALL_IDPS'
);
